import {
    FormGroup,
    ValidatorFn,
    AbstractControl,
    ValidationErrors,
  } from "@angular/forms";
  
  export const validateRequiredCheckbox =
    (): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
      if (control.value !== true) return { checkBox: "Required" };
      return null;
    };
  
  export const randomStringGenerator = () =>
    (Math.random() + 1).toString(36).substring(7);
  
  export function patternValidator(
    regex: RegExp,
    error: ValidationErrors
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
  
      const valid = regex.test(control.value);
  
      return valid ? null : error;
    };
  }
  
  
  export function ConfirmedValidator(
    controlName: string,
    matchingControlName: string
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control as FormGroup;
      const controlToValidate = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
  
      if (!controlToValidate || !matchingControl) {
        return null; 
      }
  
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return null; // Skip if other validators already reported an error
      }
  
      if (controlToValidate.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
  
      return null;
    };
  }
  
  